<div class="table-scroll-wrapper" id="table-scroll-wrapper">
	<div class="table-responsive" [ngClass]="{'no-record': !expenses || expenses.controls.length == 0}">
		<table class="data-table__table" [ngClass]="{'bt':isMobileView}">

			<thead>
				<tr>
					<th class="th-date" scope="col" i18n="@@expenses.date_of_pay">Date of Pay</th>
					<th class="th-expense-description" scope="col" i18n="@@expenses.description">Expense Description</th>
					<th class="th-amount" scope="col" i18n="@@expenses.cost" >Cost</th>
					<th class="th-vat-include" scope="col" *ngIf="isProPlan" i18n="@@expenses.subject_to_vat" >Subject to VAT</th>
					<th class="th-editdelete"></th>
					<th class="th-editdelete"></th>
				</tr>
			</thead>

			<tbody>
				
				<ng-container *ngIf="expenses?.controls.length > 0; else noRecord">
					<ng-container *ngFor="let row of expenses?.controls | paginate: paginator; index as i;">
						<!-- <tr *ngIf="row.get('edit').value; else expenseReadOnly" class="pe-fieldset expenses-form" [formGroup]="row">

							<td class="td-project-name" i18n-data-th="@@expenses.project" data-th="Project">
								<span class="bt-content">
									<fieldset [ngClass]="{'has-error': isSubmitted(row) && row.get('invoice_id').errors?.required}">
										<select nice-select name="invoice_id" formControlName="invoice_id">
											<option [value]="null" i18n="@@expenses.select_project" >Select Project</option>
											<option *ngFor="let invoice of invoicesList" [value]="invoice.id">{{ invoice.title }}</option>
										</select>
										<span class="field-error" i18n="@@error.required">Required</span>
									</fieldset>
								</span>
							</td>

							<td i18n-data-th="@@expenses.date_of_pay" data-th="Date of Pay">
								<span class="bt-content">
									<fieldset [ngClass]="{'has-error': isSubmitted(row) && row.get('expense_date').errors?.required}">
										<div class="date-input-wrap">
											<input date-dropper type="text" formControlName="expense_date" data-large-default="true"
												class="date-input" data-theme="teamup" data-dd-format="d/m/Y" />
										</div>
										<span class="field-error" i18n="@@error.required">Required</span>
									</fieldset>
								</span>
							</td>

							<td class="td-expense-description" i18n-data-th="@@expenses.description" data-th="Expense Description">
								<span class="bt-content">
									<fieldset [ngClass]="{'has-error': isSubmitted(row) && row.get('description').errors?.required}">
										<input type="text" name="description" formControlName="description" i18n-placeholder="@@expenses.enter_description"
											placeholder="Type Here" />
										<span class="field-error" i18n="@@error.required">Required</span>
									</fieldset>
								</span>
							</td>

							<td class="td-cost" i18n-data-th="@@expenses.cost" data-th="Cost">
								<span class="bt-content">
									<fieldset [ngClass]="{'has-error': isSubmitted(row) && row.get('cost').errors?.required}">
										<input type="text" placeholder="{{ 0.00 | myCurrency }}" name="cost" formControlName="cost" />
										<span class="field-error" i18n="@@error.required">Required</span>
									</fieldset>
								</span>
							</td>

							<td *ngIf="isProPlan" class="td-vat-include" i18n-data-th="@@expenses.vat_include" data-th="VAT Included">
								<span class="bt-content">
									<input class="styled-checkbox" id="task-tax-{{i}}" type="checkbox"
										[formControl]="row.controls.vat_include">
									<label for="task-tax-{{i}}"></label>
								</span>
							</td>

							<td class="td-edit-icon add-btn-wrapper">
								<span class="bt-content">
									<a class="save" href="javascript:void(0);" (click)="onSubmitEditExpense(row)">
										<svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="12" height="12" viewBox="0 0 24 24">
											<path d="M 22.59375 3.5 L 8.0625 18.1875 L 1.40625 11.5625 L 0 13 L 8.0625 21 L 24 4.9375 Z"></path>
										</svg>
									</a>
									<a class="cross" href="javascript:void(0);" (click)="cancelEditFrom(row)">
										<svg version="1.1" x="0px" y="0px" viewBox="0 0 14 14" width="14" height="14"
											style="enable-background:new 0 0 14 14;" xml:space="preserve">
											<path class="svg-stroke" fill="none" stroke-width="2" stroke-linecap="square"
												d="M2.8,11.2l8.5-8.5 M2.8,2.8l8.5,8.5" />
										</svg>
									</a>
								</span>
							</td>

						</tr> -->

						<!-- <ng-template #expenseReadOnly> -->
							<tr>
								<td class="td-date" i18n-data-th="@@expenses.date_of_pay" data-th="Date of Pay">
									<span class="bt-content">
										<div class="date">
											<span class="day">{{ row.get('expense_date').value | date:'dd' }}</span>
											<span class="month">{{ row.get('expense_date').value | date:'MMM' }}</span>
										</div>
									</span>
								</td>
								
								<td class="td-expense-description" i18n-data-th="@@expenses.description" data-th="Expense Description">
									<span class="bt-content">
										{{ row.get('description').value }}
									</span>
								</td>
								
								<td class="td-amount" i18n-data-th="@@expenses.cost" data-th="Cost">
									<span class="bt-content">
										<div class="amount">
											<span class="sar" [innerHtml]="userInfo?.currency_symbol"></span>
											<span class="price">{{ row.get('cost').value }}</span>
										</div>
									</span>
								</td>
								
								<td *ngIf="isProPlan"  class="td-vat-include" i18n-data-th="@@expenses.vat_include" data-th="VAT Included">
									<span class="bt-content">
										<input class="styled-checkbox" id="task-tax-{{i}}" [checked]="!!row.get('vat_include').value"
												type="checkbox" disabled>
										<label for="task-tax-{{i}}"></label>
									</span>
								</td>
								
								<td class="td-editdelete">
									<a href="javascript:void(0);" class="delete" (click)="deleteExpense(row)">
										<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22">
											<g fill="none" fill-rule="evenodd">
												<g fill="#FB4575">
													<path d="M8.25 10.083c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm5.5 0c.504 0 .917.413.917.917v3.667c0 .504-.413.916-.917.916s-.917-.412-.917-.916V11c0-.504.413-.917.917-.917zm2.75 7.334c0 .505-.41.916-.917.916H6.417c-.506 0-.917-.411-.917-.916V7.333h11v10.084zM9.167 3.967c0-.142.196-.3.458-.3h2.75c.262 0 .458.158.458.3V5.5H9.167V3.967zM19.25 5.5h-4.583V3.967c0-1.177-1.028-2.134-2.292-2.134h-2.75c-1.264 0-2.292.957-2.292 2.134V5.5H2.75c-.504 0-.917.412-.917.917 0 .504.413.916.917.916h.917v10.084c0 1.516 1.234 2.75 2.75 2.75h9.166c1.516 0 2.75-1.234 2.75-2.75V7.333h.917c.504 0 .917-.412.917-.916 0-.505-.413-.917-.917-.917z" transform="translate(-244 -54) translate(244 53) translate(0 1)"/>
												</g>
											</g>
										</svg>
									</a>
									
									<a href="javascript:void(0);" class="edit mr-3" (click)="editExpenses(row)">
										<svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 19 19">
											<g fill="none" fill-rule="evenodd">
												<g fill="#1C6AB6">
													<path d="M12.683 8.444l-2.134-2.137 1.542-1.545 2.133 2.136-1.541 1.546zM7.189 13.95l-2.357.214.209-2.343 4.447-4.453 2.134 2.137-4.433 4.445zm8.174-8.156h-.001l-2.168-2.171c-.587-.586-1.595-.614-2.15-.055L3.92 10.701c-.258.258-.418.6-.451.962l-.3 3.306c-.02.234.062.466.229.632.15.15.351.232.56.232.024 0 .048 0 .071-.003l3.302-.3c.363-.034.704-.193.961-.45l7.123-7.133c.577-.579.552-1.544-.053-2.152z" transform="translate(-875 -616) translate(96 587) translate(779 29)"/>
												</g>
											</g>
										</svg>
									</a>
								</td>
								<td class="td-editdelete">
									<a *ngIf="!row.get('has_child_expense').value && (row.get('parent_expense_id').value == null)" href="javascript:void(0);" (click)="openRecallExpenseModal(row)" class="recall-invoice" i18n="@@ts.make_a_refund">Make a refund</a>
								</td>
							</tr>
						<!-- </ng-template> -->
					</ng-container>
				</ng-container>

				<ng-template #noRecord>
					<tr>
						<td [attr.colspan]="isProPlan ? 5 : 4" class="text-center font-weight-normal"> 
							<ng-container *ngIf="loading; else noRecord" i18n="@@common.loading">Loading...</ng-container> 
							<ng-template #noRecord>
								<ng-container i18n="@@common.no_record_found">No record found.</ng-container> 
							</ng-template>
						</td>
					</tr>
				</ng-template>
			</tbody>
		</table>
	</div><!-- end table-responsive -->

	<!-- Start Paginator -->
	<ng-container *ngIf="paginator.totalItems > 0">
		<div class="pagination_wrapper">
			<div class="showing_results">
				<div class="select_wrapper">
					<ng-container i18n="@@show">Show</ng-container>
					<select class="select-link tab-links-select" id="tab-links-select" nice-select
						[(ngModel)]="paginator.itemsPerPage" (change)="onChangeItemsPerPage($event, p)">
						<option *ngFor="let option of itemsPerPageOptions" [value]="option">{{ option }}</option>
					</select>
					<ng-container i18n="@@items">items</ng-container>
				</div>
				<div class="results_list" *ngIf="paginator?.from || paginator?.to">
					Showing from {{ paginator?.from }} to {{ paginator?.to }} of {{ paginator?.totalItems }} items
				</div>
			</div>
			<nav pagination-template #p="paginationApi" [id]="paginator.id" (pageChange)="getPage($event)" aria-label="...">
				<ul class="pagination justify-content-center">
					<li class="page-item" [class.disabled]="p.isFirstPage()">
						<a *ngIf="!p.isFirstPage()" class="page-link prev" tabindex="-1" (click)="p.previous()">
							<svg width="7.5" height="30" style="padding-top: 7px;">
								<path d="M6.75 12.75l-6-6 6-6" fill="none" class="color-stroke" stroke-linecap="round"
									stroke-linejoin="round" stroke-width="1.5" /></svg>
						</a>
					</li>

					<li *ngFor="let page of p.pages" class="page-item" [class.active]="p.getCurrent() === page.value">
						<a *ngIf="p.getCurrent() !== page.value" (click)="p.setCurrent(page.value)" class="page-link">
							<span>{{ page.label }}</span>
						</a>
						<a *ngIf="p.getCurrent() === page.value" class="page-link">{{page.label}}
							<span class="sr-only">(current)</span></a>
					</li>

					<li class="page-item" [class.disabled]="p.isLastPage()">
						<a *ngIf="!p.isLastPage()" (click)="p.next()" class="page-link next">
							<svg width="7.5" height="30" style="padding-top: 7px;">
								<path d="M.75.75l6 6-6 6" fill="none" class="color-stroke" stroke-linecap="round" stroke-linejoin="round"
									stroke-width="1.5" /></svg>
						</a>
					</li>
				</ul>
			</nav>
		</div>
	</ng-container>
	<!--End Paginator -->
</div><!-- end outer-table-wrap -->